<div class="repo-business-list">
  <div class="container-fluid">
    <div class="bg-white p-3 mt-3">
      <div class="row">
        <div class="col-md-5 col-sm-12">
          <h1>
            {{ isUSA ? "Organizations" : "Organisations" }} & Contacts
          </h1>
        </div>
      </div>
      <div class="row  mt-5">
        <div class="col-auto">
          <!-- Bootstrap Button Group -->

          <button type="button"
                  class="btn btn-outline-primary me-1"
                  [class.active]="activeTab === 'organizations'"
                  (click)="loadTab('organizations')">
            {{ isUSA ? "Organizations" : "Organisations" }}
          </button>
          <button type="button"
                  class="btn btn-outline-primary me-1"
                  [class.active]="activeTab === 'contacts'"
                  (click)="loadTab('contacts')">
            Contacts
          </button>
          <button type="button"
                  class="btn btn-outline-primary"
                  [class.active]="activeTab === 'positions'"
                  (click)="loadTab('positions')">
            Positions
          </button>

        </div>

        <div class="col">
          <div class="row align-self-center justify-content-end">
            <div class="col-auto text-end">
              <div class="row align-self-center g-3 flex justify-content-end">
                <div class="col-auto" style="padding-top:2px;">
                  <app-search-box placeholder="Search..." [(ngModel)]="searchTerm">
                  </app-search-box>
                </div>
                <div class="col-auto" style="margin-top: 1.1rem" *ngIf="activeTab === 'organizations'">
                  <button type="button"
                          class="btn h-btn-search-box btn-primary btn-sm me-1"
                          (click)="openRepoBusinessPopup(null)"
                          title="Add {{ isUSA ? 'Organization' : 'Organisation' }}">
                    <i class="fa fa-plus"></i> Add {{ isUSA ? 'Organization' : 'Organisation' }}
                  </button>


                  <button type="button"
                          class="btn h-btn-search-box btn-secondary btn-sm"
                          (click)="openPositionListPopup()"
                          title="Add Position">
                    <i class="fa fa-plus"></i> Positions
                  </button>
                </div>
                <div class="col-auto" style="margin-top: 1.1rem" *ngIf="activeTab === 'contacts'">
                  <button class="btn h-btn-search-box btn-primary btn-sm"
                          type="button"
                          (click)="AddRepoContact()">
                    <i class="fa fa-plus"></i> Add Contact
                  </button>
                </div>
                <div class="col-auto" style="margin-top: 1.1rem" *ngIf="activeTab === 'positions'">
                  <button class="btn h-btn-search-box btn-secondary btn-sm"
                          type="button"
                          (click)="AddRepoPosition()">
                    <i class="fa fa-plus"></i> Add Position
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div *ngIf="activeTab === 'organizations'">
          <app-repo-business-list *ngIf="repoBusinesses" (editRepoBusiness)="openRepoBusinessPopup($event)" [isUSA]="isUSA" [(searchTerm)]="searchTerm" [businesses]="repoBusinesses" [positionsUpdated]="positionsUpdated" [(positions)]="positions"></app-repo-business-list>
        </div>
        <div *ngIf="activeTab === 'contacts'">
          <div class="table-responsive data-grid mt-3 sticky-header-table sticky-header-table-height-md" #tableContact>
            <app-repocontact-list [isShowOrgCol]="true" [isUSA]="isUSA" [(searchTerm)]="searchTerm" [tableContact]="tableContact" [(contacts)]="allContacts" (editRepoContact)="EditRepoContact($event)" (deleteRepoContact)="DeleteRepoContact($event)"></app-repocontact-list>
          </div>
        </div>
        <div *ngIf="activeTab === 'positions'">
          <div class="table-responsive data-grid mt-3 sticky-header-table sticky-header-table-height-md" #tablePosition>
            <app-position-list (editRepoPosition)="EditRepoPosition($event)" [isUSA]="isUSA" [(searchTerm)]="searchTerm" [tablePosition]="tablePosition" [(positions)]="positions"></app-position-list>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
